
    import { Vue, Component, Prop } from 'vue-property-decorator';

    @Component({ name: 'RefreshLoader' })
    export default class RefreshLoader extends Vue {
        @Prop({ default: false }) readonly show!: boolean;
    }
